import { Container } from "@sainsburys-tech/luna-grid"
import { Display3 } from "@sainsburys-tech/luna-typography"
import GuardingDailyActivities from "../components/GuardingDailyActivities/GuardingDailyActivities"
import ReportGuardingDailyActivity from "../components/ReportGuardingDailyActivity"

const GuardingDailyActivitiesPage = () => {

  const pageTitle = () => {
    return (
      <Container className="ln-u-padding-bottom*4" size="xs">
        <div>
          <Display3 id="s-page-title" className="s-page-title ln-u-padding-left*2">
            Reported daily activities
          </Display3>
        </div>
      </Container>
    )
  }

  return (
    <div className="s-reported-incidents-dashboard ln-u-1/1">
      
      <ReportGuardingDailyActivity />

      {pageTitle()}

      <Container className="s-reported-incidents" size="xs">
        <GuardingDailyActivities />
      </Container>
    </div>
  )
}

export default GuardingDailyActivitiesPage